import { render, staticRenderFns } from "./DataSelect.vue?vue&type=template&id=12640ed9"
import script from "./DataSelect.vue?vue&type=script&lang=js"
export * from "./DataSelect.vue?vue&type=script&lang=js"
import style0 from "./DataSelect.vue?vue&type=style&index=0&id=12640ed9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports